import { ColorByOption } from '@paragon/contract-library';

export const COLOR_BY_LABELS: { [option in ColorByOption]: string } = {
  Combined: 'Worst Capacity - All Load Cases',
  LumberGeometry: 'Lumber Geometry',
  LumberProperties: 'Lumber Properties',
  None: 'No Coloring',
};

export const DEFAULT_COLOR_BY_OPTIONS = ['LumberProperties', 'LumberGeometry', 'None'] satisfies ColorByOption[];
